enum FontSize {
  tiny = "0.75rem",
  small = "0.875rem",
  medium = "1rem",
  large = "1.25rem",
  huge = "1.5rem",
  extraHuge = "2.25rem",
  halfExtraHuge = "4rem",
  doubleExtraHuge = "6rem"
}

const ThemeSize: Record<keyof typeof FontSize, string> = FontSize;

export default ThemeSize;
